// extracted by mini-css-extract-plugin
export default {"task":"Task_task__vinSw","animateTask":"Task_animateTask__ke0h6","task__color":"Task_task__color__cWSNJ","task__text":"Task_task__text__EG5uz","task__done":"Task_task__done__THN5h"};